var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import { v4 as uuidV4 } from 'uuid';
var Klaviyo = React.forwardRef(function (props, ref) {
    var id = useState(uuidV4().replace(/-/g, ''))[0];
    return (_jsxs("svg", __assign({}, props, { ref: ref, width: "40", height: "40", viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [_jsx("g", __assign({ clipPath: "url(#clip0".concat(id, ")") }, { children: _jsx("g", __assign({ clipPath: "url(#clip1".concat(id, ")") }, { children: _jsx("path", { d: "M35 30.0893H5V10H35L28.7168 20.0446L35 30.0893Z", fill: "black" }) })) })), _jsxs("defs", { children: [_jsx("clipPath", __assign({ id: "clip0".concat(id) }, { children: _jsx("rect", { width: "40", height: "40", fill: "white" }) })), _jsx("clipPath", __assign({ id: "clip1".concat(id) }, { children: _jsx("rect", { width: "30", height: "20.0893", fill: "white", transform: "translate(5 10)" }) }))] })] })));
});
export default Klaviyo;
